import { Button, CircularProgress, Fade, Link, makeStyles, Menu, MenuItem } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import clsx from 'clsx';
import { StarsIcon, SystemModelIcons, ViewIcon, TransactionIcon, SimulationIcon } from '../icons';
import { useHistory } from 'react-router-dom'
import CustomPromptMenu from './CustomPromptMenu';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeAiAssistantModal, handleSnackBar, invokeGetService, invokePostService, openAiPromptModal, setAiRequestEntity, setFocusElement, setInnerScreenRender, setLlmQuery, setReRender, setTabOnFocus, toggleRightDrawer, updateAiAssistant } from '../../../store/global/actions';
import { getDetailsFromUrl } from '../../../services/blueprint';
import AlertDialog from '../../atoms/alertDialog/AlertDialog';
import { useRef } from 'react';
import { useEffect } from 'react';
import AiGeneratedItemsModal from './AiGeneratedItemsModal';
import AiGenerationNotifications from './AiGenerationNotifications';
import { generateMongoId } from '../../../utils/commonUtils';
import './PromptModal.css'
import { hasArrayDifference } from '../../../utils/llmUtils';
import { getAiAssistant, getRightDrawerStatus } from '../../../store/global/selectors';
import { generateViewTransactionWithAI } from '../../../services/llm/views';

const useStyles = makeStyles(() => ({
  modalContentWrapper: {
    background: '#fff',
    borderRadius: '10px',
    padding: '6px',
    width: "60%",
    maxWidth: '750px'
  },
  modalContent: {
    width: '100%',
    height: '100%',
    borderRadius: "24px",
    border: "none",
    padding: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  textarea: {
    height: '24vh',
    resize: 'none',
    width: '100%',
    border: 'none',
    outline: 'none',
    borderColor: 'rgba(0, 0, 0, 0.42)',
    '&::placeholder': {
      color: 'rgba(0, 0, 0, 0.3)', // lighter placeholder
    },

    /* Optional: for disabled state */
    '&:disabled::placeholder': {
      color: 'rgba(0, 0, 0, 0.25)',
    },
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  actionButtons: {
    marginLeft: "auto",
    display: "flex"
  },
  button: {
    textTransform: "capitalize",
    outline: 'none'
  },
  buttonGenerate: {
    background: 'rgb(72, 86, 106)',
    color: '#fff',
    '&:hover': {
      background: 'rgb(72, 86, 106)',
    }
  },
  errorInline: {
    color: "#D32F2F",
    fontSize: "0.85rem",
    marginTop: "6px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontWeight: 500,
  },
  cancelBtn: {
    marginRight: 10
  },
  alertLink: {
    cursor: "pointer",
    fontWeight: 500,
    fontSize: 14,
    color: "#2e5e8d",
    textDecoration: "underline",
    display: "inline",          // behave like text
    padding: 0,                 // remove button padding
    minWidth: "auto",           // prevent button sizing
    verticalAlign: "baseline",  // align with surrounding text
    lineHeight: "inherit",
  
    "&:hover": {
      textDecoration: "underline",
    },
  
    "&:focus": {
      outline: "none",
    },
  
    "&:active": {
      outline: "none",
    },
  },
  
  disabledLink: {
    cursor: "not-allowed",
    opacity: 0.5,
    pointerEvents: "none",
  }
}))

const menuItems = [
  {
    title: "Create/Update System Model",
    description: "Generate System model with HyperBlox Agent",
    icon: <SystemModelIcons />,
    value: "system_model",
    type: "create",
    group: "system",
    id: "sm_null"
  },
  {
    title: "Create Views",
    description: "Generate views with HyperBlox Agent",
    icon: <ViewIcon />,
    value: "views",
    type: "create",
    group: "view",
    id: "views_null"
  },
  {
    title: "Create Transactions",
    description: "Generate transactions with HyperBlox Agent",
    icon: <TransactionIcon />,
    value: "transaction",
    type: "create",
    group: "transaction",
    id: "transaction_null"

  },
  {
    title: "Create Testsuites",
    description: "Generate testsuites with HyperBlox Agent",
    icon: <SimulationIcon />,
    value: "testsuite",
    type: "create",
    group: "testsuites",
    id: "testsuites_null"
  }
]



export const PromptModal = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch();
  const history = useHistory();
  const { slug, blueprintId, screen, entityId } = getDetailsFromUrl();
  const router = useHistory()

  const { promptModalOpen, showEntityFilter, requestContext } = useSelector(getAiAssistant);

  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const [activeMenu, setActiveMenu] = useState(screen === "view" ? menuItems[1] : menuItems[0])
  const [isLoading, setLoading] = useState(false)
  const [prompt, setPrompt] = useState("");
  const [isAlertDialog, setAlertDialog] = useState(null);
  const [dotCount, setDotCount] = useState(0);
  const [progressMessage, setProgressMessage] = useState("");
  const [menuOptions, setMenuOptions] = useState(menuItems);
  const [openListModal, setOpenListModal] = useState(false);
  const [aiGeneratedItems, setAiGeneratedItems] = useState([]);
  const [aiProgress, setAiProgress] = useState([]);
  const [error, setError] = useState(false);
  const [clusterlets, setClusterlets] = useState([]);
  const [allViews, setAllViews] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [events, setEvents] = useState([]);
  const [notificationMessages, setNoficationMessage] = useState([]);
  const [menuPosition, setMenuPosition] = useState(null);
  const [sequenceId, setSequenceId] = useState("");
  const [viewList, setViewList] = useState([]);
  const [transactionList, setTransactionList] = useState([]);
  const [testSuitesList, setTestSuitesLists] = useState([]);
  const [showDBMissingAlert, setShowDBMissingAlert] = useState(false);
  const [isGenerateDBLinkClicked, SetGenerateDBLinkClicked] = useState(false);
  const [formPlaceholders, setFormPlaceholders] = useState(null);
  const [generatedItemsModalTitle, setGeneratedItemsModalTitle] = useState(null);

  const [viewConflictAlert, setViewConflictAlert] = useState(false);
  const [validationError, setValidationError] = useState([]);

  const entityStatus = (requestContext?.isCreate && showEntityFilter === false) ? "new" : (!requestContext?.isCreate && showEntityFilter === false) ? "existing" : activeMenu.type === "existing" ? "existing" : "new";
  const entityType = (requestContext?.entityType && showEntityFilter === false) ? requestContext?.entityType : activeMenu.value;

  const DBProfileConfigurations = {
    listModalTitle: "Possible Database Tables",
    formPlaceholders: {
      name: "Name of the table",
      description: "Detailed desription about what table should store."
    },
    messages: [
      'Analysing and understanding the clusterlets',
      'Finding all required tables',
      'Deciding the role of each table',
      'Identifying fields for the tables'
    ]
  }

  const rightDrawerStatus = useSelector(getRightDrawerStatus);
  

  const placeholders = {
    "system_model": {
      existing: "Generate a smart factory application for monitoring and predictive maintenance.",
      new: "Generate a smart factory application for monitoring and predictive maintenance.",
    },
    transaction: {
      existing: "Update transaction to add a mysql storage",
      new: "Generate Transactions."
    },
    views: {
      existing: "Update view to add a line chart to indicate revenue",
      new: "Generate Views."
    },
    testsuite: {
      existing: "Update testsuite to add edge conditions",
      new: "Generate Testsuites."
    },
    "database_profile": {
      existing: "Update the database profile to include a table named logs.",
      new: "Generate database profile."
    }
  };

  const generatePlaceholder = () => {
    
    return placeholders?.[entityType]?.[entityStatus] || "";
  };


  const textareaRef = useRef(null);
  const progressTimer = useRef(null);
  const dotTimer = useRef(null);

  const generateSystemModel = async (prompt, sequence_id) => {
    setLoading(true)

    let cancelInterval = handleProgressMessages(2000, [
      'Analysing and understanding the use case',
      'Finding all required components',
      'Deciding the role of each component',
      'Identifying sensors, and properties'
    ])

    dispatch(setLlmQuery(prompt))
    try {
      const response = await dispatch(invokePostService('llmGenerationSystemModelNode', { prompt: prompt, sequence_id }, []))
      cancelInterval()
      if (response?.status) {
        return { status: true, data: response.data }
      } else {
        dispatch(invokePostService('logTimeout', { content: `\n============================== Timeout Error ========================= \nBlueprint: ${blueprintId} \nType: System Model Node \nDate: ${Date.now()} \nxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx` }))
        if (response) {
          dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
        }
      }
    } catch (err) {
      console.error("Error submitting query", err);
      cancelInterval()
    }
  }

  const generateSystemModelConnections = async ({prompt, entities, sequence_id}) => {
    let cancelInterval = handleProgressMessages(2000, [
      'Defining how components are connected',
      'Building the connection between the nodes',
      'Checking rules and correctness',
      'Finalizing and optimizing the model'
    ])
    try {
      return dispatch(invokePostService('llmGenerationSystemModelConnection', { prompt: prompt, entities, sequence_id}, [])).then((response) => {
        cancelInterval()
        // if (response?.status) {
        //   return {status: true, data: response.data, isCreate: response.isCreate}
        // } else {
        //   dispatch(invokePostService('logTimeout', { content: `\n============================== Timeout Error ========================= \nBlueprint: ${blueprintId} \nType: System Model Connection \nDate: ${Date.now()} \nxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx` }))
        //   if (response) {
        //     dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
        //   }
        // }
        return response
      }).catch((error) => {
        cancelInterval()
        console.error('Generating connections from LLM failed. ', error)
      });
    } catch (err) {
      console.error("Generating connections from LLM failed", err);
      cancelInterval()
    }
  }


  const onDBMissingAlertClick = () => {
    if(isGenerateDBLinkClicked) return;
    SetGenerateDBLinkClicked(true);
    generateDatabaseTablesWithAI(String(showDBMissingAlert.delegate._id))
  }

  const handleProgressMessages = (delay = 2000, messages) => {
    let index = 0;

    if (index === 0) {
      setProgressMessage(messages[index])
    }

    const interval = setInterval(() => {
      index++;
      setProgressMessage(index >= messages.length ? messages[messages.length - 1] : messages[index])
    }, delay)

    const cancel = () => {
      clearInterval(interval)
      setProgressMessage("")
    };

    if (index === messages.length - 1) {
      cancel()
    }

    return cancel;
  }

  const handleGenerate = async (event) => {
    event.preventDefault();
    // Prompt is required for system model create/update and update of all other entities
    if ((entityStatus === "existing" || entityType === "system_model") && (!prompt || prompt.trim() === "")) {
      setError(true);
      return false;
    }

    setError(false);
    setValidationError([]);
    setLoading(true);
    dispatch(updateAiAssistant({loading: true}));
    switch (entityType) {
      case "views":
        if (activeMenu.id && activeMenu.id !== "views_null") { // To handle edit views
          
          const availableViews = [
            ...allViews.map(({ name, desc: description, _id }) => ({ name, description, _id })),
          ];
          let cancelInterval = handleProgressMessages(2000, [
            'Analyzing dashboard requirements',
            'Selecting the right widgets',
            'Organizing sections and components',
            'Validating view and transactions'
          ])
          const sequence_id = generateMongoId();
          setSequenceId(sequence_id);
          const viewToUpdate = allViews.find(tx => tx._id.toString() == activeMenu.id.toString())

          const response = await generateSingleView({ prompt, selectedView: activeMenu.id, availableViews, sequence_id, viewName: viewToUpdate.name  });
          cancelInterval()
          console.log("response--", response)
          const viewChanges = response?.data?.views;
          const generatedView = viewChanges?.update?.after?.[0];
          
          const viewName = generatedView?.name || "";
          const view_type = (viewName.includes("list") || viewName.includes("overview")) ? "summary" : "details";

          let cancelNotificationInterval;
          const updateNotificationMessages = (items) => {
            cancelNotificationInterval = handleProgressMessages(2000, items || [])
          }
         
          const viewTransactionResult = await generateViewTransactionWithAI({newView: generatedView, viewChanges, sequence_id, view_type: view_type, setNoficationMessage: updateNotificationMessages, dispatch});
          if (viewTransactionResult.status) {
            dispatch(updateAiAssistant({promptModalOpen: false, loading: false}));
            if (screen === "view" && entityId === activeMenu.id && !generatedView) {
              router.push(`/blueprint/${slug}/${blueprintId}/system-model`);
            } else if (screen === "view" && entityId === activeMenu.id && generatedView?._id && generatedView._id !== entityId && viewTransactionResult.status) {
              router.push(`/blueprint/${slug}/${blueprintId}/view/${generatedView._id}`)
            }
          }
          if (cancelNotificationInterval && typeof cancelNotificationInterval === "function") cancelNotificationInterval();
          setLoading(false);
          setMenuAnchorEl(null);
          
        } else {
          let cancelInterval = handleProgressMessages(2000, [
            'Analysing the system model',
            'Identifying the suitable views'
          ])
          const sequence_id = generateMongoId();
          setSequenceId(sequence_id);
          const response = await dispatch(invokePostService("llmGenerateViewsList", { prompt, sequence_id }, {}));
          cancelInterval()
          if (response?.status) {
            setAiGeneratedItems(response.data || []);
            setOpenListModal(true);
          }
          dispatch(updateAiAssistant({loading: false}));
          setLoading(false)
        }
        break;
      case "system_model":
        try {
          dispatch(setAiRequestEntity("system_model"))
          const sequence_id = generateMongoId();
          const data = await generateSystemModel(prompt, sequence_id);
          if (data.status) {
            const connectionsResponse = await generateSystemModelConnections( {prompt, entities: data?.data, sequence_id})
            // if(connectionsResponse.status){
            //   await generateDBStructureTables( {data: connectionsResponse.data, sequence_id, isCreate: connectionsResponse?.isCreate})
            // }

            if (connectionsResponse?.status) {
              if (screen !== "system-model") {
                router.push(`/blueprint/${slug}/${blueprintId}/system-model`)
              }
              setMenuAnchorEl(null)
              dispatch(closeAiAssistantModal());
              dispatch(setReRender())
            } else if (!connectionsResponse?.status && connectionsResponse?.data) {
              setMenuAnchorEl(null)
              dispatch(closeAiAssistantModal());
              setAlertDialog({
                message: connectionsResponse.message,
                data: connectionsResponse.data,
                deletedParts: connectionsResponse.deletedData,
                dependencies: connectionsResponse.data?.dependencies
              })
            } else {
              dispatch(invokePostService('logTimeout', { content: `\n============================== Timeout Error ========================= \nBlueprint: ${blueprintId} \nType: System Model Database profile \nDate: ${Date.now()} \nxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx` }))
    
              if (connectionsResponse) {
                dispatch(handleSnackBar({ open: true, message: connectionsResponse.message, severity: "error" }));
              }
            }
            setLoading(false);


          }
          dispatch(setAiRequestEntity(null));
          dispatch(updateAiAssistant({ loading: false}));
        } catch (error) {
          console.error(error)
          dispatch(setAiRequestEntity(null));
          dispatch(updateAiAssistant({ loading: false}));
          setLoading(false)
        }
        break;
      case "transaction":

        if (activeMenu.id && activeMenu.id !== "transaction_null") { // For handling edit of transaction
          let cancelInterval = handleProgressMessages(2000, [
            'Analyzing your requirements',
            'Understanding purpose of the transaction',
            'Updating the events',
            'Preparing event type',
            'Applying platform rules and checks',
            'Finalizing the transaction'
          ])
          localStorage.setItem("SHOW_LOADER", true);
          const sequence_id = generateMongoId();
          setSequenceId(sequence_id);
          const transactionToUpdate = transactions.find(tx => tx._id.toString() == activeMenu.id.toString())
          const response = await generateTransaction(prompt, activeMenu.id, sequence_id, transactionToUpdate.name);
          cancelInterval()
          if (screen === "transaction" && entityId === activeMenu.id && !response?.data) {
            router.push(`/blueprint/${slug}/${blueprintId}/system-model`);
          }
         
          clearTimeout(progressTimer.current);
          setProgressMessage("");
          clearInterval(dotTimer.current);
          setDotCount(0);

          setLoading(false);
          setMenuAnchorEl(null);
          dispatch(updateAiAssistant({promptModalOpen: false, loading: false}));
        } else {

          let cancelInterval = handleProgressMessages(2000, [
            'Understanding the system model and views',
            'Identifying required transactions and coverage',
            'Finalizing transaction list'
          ])
          const sequence_id = generateMongoId();
          setSequenceId(sequence_id);
          const response = await dispatch(invokePostService("llmGenerateTransactionList", { prompt, sequence_id }, {}));
          cancelInterval()
          if (response?.status) {
            const data = response.data;
            setAiGeneratedItems(response.data || []);
            setOpenListModal(true);
          }
          dispatch(updateAiAssistant({loading: false}));
          clearTimeout(progressTimer.current);
          setProgressMessage("");
          clearInterval(dotTimer.current);
          setDotCount(0);
          setLoading(false)
        }
        break;
      case "testsuite":

        if (activeMenu.id && activeMenu.id !== "testsuites_null") {
          handleTestuiteUpdate(activeMenu.id)
          return
        }

        let cancelInterval = handleProgressMessages(2000, [
          'Understanding the transactions',
          'Identifying testable scenarios',
          'Reviewing completeness and gaps',
          'Finalizing testsuite list'
        ])
        const sequence_id = generateMongoId();
        setSequenceId(sequence_id);
        const generatedScneriosResponse = await dispatch(invokePostService("llGenerateSimulationScenarios", { prompt, sequence_id }, {}));
        cancelInterval()
        setLoading(false);
        dispatch(updateAiAssistant({loading: false}));
        if (generatedScneriosResponse.status) {
          setAiGeneratedItems(generatedScneriosResponse.data || "");
          setOpenListModal(true)
        } else {
          if (generatedScneriosResponse.transactionsExist === false) {
            dispatch(handleSnackBar({ open: true, message: "No transactions available to find scenarios", severity: "error" }));
          }
        }

        break;

      case "database_profile": 
        generateDatabaseTablesWithAI(requestContext?.entity?._id);
        break;
      default:
        break;
    }
    if (entityType !== "database_profile") {
      dispatch(setReRender());
    }
  }

  const handleTestuiteUpdate = async (id) => {
    try {
      setProgressMessage("Analyzing testsuite to update");
      progressTimer.current = setTimeout(() => {
        setProgressMessage("Generating updated testsuite");
      }, 2000);
      const sequence_id = generateMongoId();

      const response = await dispatch(invokePostService("llGenerateSimulationTestsuiteUpdate", { prompt, selectedTestsuite: id, sequence_id }, {}));


      setLoading(false);
      clearTimeout(progressTimer.current);
      setProgressMessage("");
      clearInterval(dotTimer.current);
      setDotCount(0);
      setMenuAnchorEl(null)
      dispatch(updateAiAssistant({promptModalOpen: false, loading: false}));

      if (response.status) {
        dispatch(setReRender());
        dispatch(handleSnackBar({ open: true, message: response.message, severity: "success" }));
      } else {
        if (response.testcaseDeletions) {
          setMenuAnchorEl(null)
          setAlertDialog({ type: 'testsuite', message: response.message, data: response.data })
          return
        }
        dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
      }

    } catch (error) {
      console.error('Handling testsuite updated failed.', error);
      dispatch(updateAiAssistant({loading: false}));
    }
  }

  const onDangerContinue = () => {
    try {
      setLoading(true)
      if (isAlertDialog.type === "testsuite") {
        onTestsuiteUpdateConfirmation()
        return;
      }

      dispatch(invokePostService('confirmSystemModelDeletion', isAlertDialog?.data, []))
        .then((response) => {
          if (response.status) {
            if (screen !== "system-model") {
              router.push(`/blueprint/${slug}/${blueprintId}/system-model`)
            }
            setMenuAnchorEl(null)
            dispatch(closeAiAssistantModal());
            dispatch(setReRender())
            setAlertDialog(false)
          } else {
            dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
          }
          setLoading(false);
          setAlertDialog(false)
        })
        .catch((error) => {
          console.error(error)
          setLoading(false);
          setAlertDialog(false)
        });
    } catch (err) {
      console.error("Error on confirming query", err);
    }
  }

  const onTestsuiteUpdateConfirmation = async () => {
    try {
      dispatch(invokePostService('llGenerateSimulationConfirmTestsuiteModification', isAlertDialog?.data, []))
        .then((response) => {
          dispatch(updateAiAssistant({loading: false}));
          setLoading(false);
          if (response.status) {
            setMenuAnchorEl(null)
            dispatch(closeAiAssistantModal());
            dispatch(setReRender())
            setAlertDialog(false);
            dispatch(handleSnackBar({ open: true, message: response.message, severity: "success" }));
          } else {
            dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
          }
          setLoading(false);
          setAlertDialog(false)
        })
        .catch((error) => {
          console.error(`Confirming testsuite updated failed`, error)
          dispatch(updateAiAssistant({loading: false}));
          setLoading(false);
          setAlertDialog(false)
        });
    } catch (err) {
      dispatch(updateAiAssistant({loading: false}));
      setLoading(false);
      console.error("Confirming testsuite updated failed", err);
    }
  }

  const getInitialData = async () => {
    
    const promises = [
      dispatch(invokeGetService('getBlueprintConstructs', {}))
    ]

    return await Promise.all(promises)

  }

  useEffect(() => {
    getInitialData().then(([constructs]) => {

      if (constructs?.status) {
        setViewList(constructs.data?.views)
        setTransactionList(constructs.data.transactions)  
        setTestSuitesLists(constructs.data.testSuites)


      } else {
        console.error("Fetching all constructs failed", constructs);
      }

    })

  }, [isLoading])


  useEffect(() => {
    if (isLoading) {
      dotTimer.current = setInterval(() => {
        setDotCount((prev) => (prev === 3 ? 0 : prev + 1));
      }, 500);
    } else {
      clearInterval(dotTimer.current);
      setDotCount(0);
    }

    return () => clearInterval(dotTimer.current);
  }, [isLoading]);

  useEffect(() => {
    return () => {
      // Cleanup timer on unmount
      if (progressTimer.current) clearTimeout(progressTimer.current);
      if (dotTimer.current) clearInterval(dotTimer.current);
    };
  }, []);

  useEffect(() => {
    generatePlaceholder()
  }, [activeMenu]);

  useEffect(() => {
    if (promptModalOpen) {
      setError(false);
      setPrompt("");
      fetchMainConstructs();
      setActiveMenu(screen === "view" ? menuItems[1] : screen === "transaction" ? menuItems[2] : menuItems[0]);
    }
  }, [promptModalOpen]);

  useEffect(() => {
    if (promptModalOpen && !isLoading) {
      setTimeout(() => textareaRef.current?.focus(), 100);
    }
  }, [promptModalOpen, isLoading, menuAnchorEl]);

  const fetchMainConstructs = () => {
    Promise.all([
      dispatch(invokeGetService('getMainConstructs', [])),
      dispatch(invokeGetService('getAllEvents', [])),
      dispatch(invokeGetService('fetchDatabaseProfileAndDelegateDetails', {})),
    ])
      .then(([response, allEventsResponse, mysqlDelegateDetails]) => {
        if (response?.status === true && response?.data) {
          const newMenuItems = [...menuItems];
          const { views = [], transactions = [], testSuites = [], clusterlets = [] } = response.data;
          setClusterlets(clusterlets)
          setAllViews(views);
          setTransactions(transactions)

          views.forEach(view => {
            const obj = {
              title: `Update View: ${view.name}`,
              description: view.desc,
              icon: <ViewIcon />,
              value: "views",
              type: "existing",
              group: "view",
              id: view._id.toString()
            }
            newMenuItems.push(obj);
          });

          transactions.forEach(transaction => {
            const obj = {
              title: `Update Transaction: ${transaction.name}`,
              description: transaction.description,
              icon: <TransactionIcon />,
              value: "transaction",
              type: "existing",
              group: "transaction",
              id: transaction._id.toString()
            }
            newMenuItems.push(obj);
          });

          testSuites?.forEach(testsuite => {
            const obj = {
              title: `Update Testsuite: ${testsuite.name}`,
              description: testsuite.description,
              icon: <SimulationIcon />,
              value: "testsuite",
              type: "existing",
              group: "testsuites",
              id: testsuite._id.toString()
            }
            newMenuItems.push(obj);
          })

          setMenuOptions(newMenuItems);
        }

        if (allEventsResponse?.status && allEventsResponse.data) {
          setEvents(allEventsResponse.data);
        }

        if(mysqlDelegateDetails.status && mysqlDelegateDetails.data){
          SetGenerateDBLinkClicked(false);
          if(mysqlDelegateDetails.data.databaseProfile === undefined ){
            setShowDBMissingAlert({delegate: mysqlDelegateDetails.data.delegate})
          }else{
            setShowDBMissingAlert(false);
          }
        }else{
          setShowDBMissingAlert(false);
        }


      });
  }

  const onChangePrompt = () => {
    SetGenerateDBLinkClicked(false);
    // setFormPlaceholders(null);
    // setGeneratedItemsModalTitle(null);

    setOpenListModal(false);
  }

  const onCloseListModal = () => {
    dispatch(updateAiAssistant({promptModalOpen: false, requestContext: {}}));
    setOpenListModal(false);
  }

  const generateTransaction = async (prompt, selectedTransaction, sequence_id, transactionName) => {
    try {
      const transactionDetails = await dispatch(invokePostService("llmGenerateTransactionEvents", { prompt, selectedTransaction, sequence_id, transactionName }, {}));  
      if(transactionDetails.status){
        setNoficationMessage([
          'Analyzing transaction structure',
          'Inspecting events and message schema',
          'Identifying business logic',
          'Mapping logic to handlers',
          'Generating handler comments',
          'Finalizing documentation'
        ])
        const handlerStatus = await dispatch(invokePostService("llmGenerateFunctionalTransactionHandlers", {
          generatedTransactions: transactionDetails.generatedTransactions,
          generatedMessages: transactionDetails.generatedMessages,
          selectedTransactionData: transactionDetails.selectedTransactionData,
          sequenceId
        }));
  
        setNoficationMessage([
          'Generating handler code structure',
          'Implementing business logic',
          'Mapping inputs and outputs',
          'Validating handler behavior',
          'Optimizing generated code',
          'Finalizing handler code'
        ]);

        const handlerCodeStatus = await dispatch(invokePostService("generateTransactionHandlerCode", {
          undoData: handlerStatus.undoData,
          entityChangeSet: handlerStatus.entityChangeSet,
          isEdit: handlerStatus.isEdit,
          sequenceId
        }));
  
      
        return handlerStatus
      }
    } catch (error) {
      console.error("Transaction generation failed:", error); 
      setNoficationMessage([ "An error occurred while generating handlers" ]); 
      return { status: false, error: error.message || "Unknown error" };
    }
  };

  const generateSingleView = async ({ prompt, selectedView, availableViews, type, sequence_id, viewName }) => {
    try{
      setNoficationMessage([
        'Analyzing dashboard requirements',
        'Selecting the right widgets',
        'Organizing sections and components',
        'Validating generated view'
      ])
      const viewResponse = await dispatch(invokePostService("llmGenerateViews", { prompt, selectedView, availableViews, type, sequence_id, viewName }, {}));

      // Empty array if no tables exist
      // const tables = viewResponse?.databases?.[0]?.attributes?.tables || [];
      // let savedDetails
      // let invalidHandler = false;

      // const dataToSave = await generateFetchTransactionsForSections({viewResponse: viewResponse, tables, availableViews, selectedView, type, sequence_id, isCreate: viewResponse.isCreate})

      // if(!dataToSave) return {status: false}
      
      // savedDetails = await dispatch(invokePostService('llmSaveViewAndFetchTxns', {
      //     generatedFields: dataToSave?.generatedFields, 
      //     generatedViews: dataToSave?.generatedViews, 
      //     newTransactions: dataToSave?.newTransactions,
      //     newFields: dataToSave?.newFields,
      //     newMessages: dataToSave?.newMessages,
      //     newEvents: dataToSave?.newEvents,
      //     generatedMappedTransactions: dataToSave?.newMappedTransactions,
      //     newHandlers: dataToSave?.newHandlers || [],
      //     availableViews,
      //     selectedView
      // }))

      // if(invalidHandler){
      //   return {status: false, message: "Invalid handler generated by AI"}
      // }

      return viewResponse;
    }catch(error){
      console.error(error)
      return {status: false}
    }
  };

  const generateFetchTransactionsForSections = async ({viewResponse, tables, type, sequence_id, isCreate}) => {
    try{
      const LLMGeneratedViews = viewResponse.generatedViews
      if(!LLMGeneratedViews.views || LLMGeneratedViews.views?.length === 0) return {generatedViews: {views: []}}

      const newTransactions = [];
      const newFields = [];
      const newMessages = [];
      const newEvents = [];
      const newMappedTransactions = [];
      const newHandlers = [];
      let generatedFields = [], generatedViews = {};

      for(let view of LLMGeneratedViews.views){
        for(let section of view.sections){
          let sectionData = {
            section_name: section.name, 
            section_description: section.description, 
            section_slug: section.slug, 
            view_name: view.name,
            view_description: view.description,
            widgets: section.widgets
          }

          let iterate = true;
          let iterateCount = 0;
          const ITERATE_THRESHOLD = 1

          const sectionResponse = await dispatch(invokePostService("llmGenerateTxns", {section: sectionData, existingSystemModel: viewResponse?.existingModelData, sequence_id, isCreate}, {}))
        
          while(iterate && ITERATE_THRESHOLD >= iterateCount){
              ++iterateCount;
      
              setNoficationMessage([
                "Inspecting view data dependencies",
                "Identifying data sources",
                "Estimating data volume and access patterns",
                "Designing optimal query strategy",
                "Determining number of required queries",
                "Validating query plan for completeness"
              ])
              const queryPlan = await dispatch(invokePostService('llmQueryPlan', {
                generatedFields: viewResponse?.generatedFields, 
                generatedViews: generatedViews?.views?.length > 0 ? generatedViews : viewResponse?.generatedViews, 
                tables, 
                generatedMappedTransactions: sectionResponse?.generatedMappedTransactions,
                section_name: section.slug,
                sequence_id,
                isCreate
              }))

              if(!queryPlan.status) continue;
      
              setNoficationMessage([
                "Analyzing transaction flow requirements",
                "Identifying inputs, outputs, and intermediate data",
                "Defining message payload structure",
                "Structuring request and response schemas",
                "Ensuring compatibility with handlers",
                "Reviewing message structure integrity",
                "Finalizing transaction message definition"
              ])
              const messageFields = await dispatch(invokePostService('llmViewMessageDef', {
                generatedFields: queryPlan?.generatedFields, 
                generatedViews: queryPlan?.generatedViews, 
                tables, 
                generatedMappedTransactions: queryPlan?.generatedMappedTransactions,
                view_type: type,
                section_name: section.slug,
                view_name: view.slug,
                sequence_id,
                isCreate
              }))

              if(!messageFields.status) continue;

      
              setNoficationMessage([
                "Analyzing transaction execution flow",
                "Identifying required handlers (OnSend / OnReceive)",
                "Defining responsibilities for each handler",
                "Specifying data inputs and outputs per handler",
                "Documenting business logic at a high level",
                "Validating handler responsibilities and boundaries",
                "Finalizing handler definitions"
              ])
              const handlerDefinitions = await dispatch(invokePostService('llmFetchHandlerDef', {
                generatedFields: queryPlan?.generatedFields, 
                generatedViews: messageFields?.generatedViews, 
                tables, 
                newTransactions: messageFields?.newTransactions,
                newFields: messageFields?.newFields,
                newMessages: messageFields?.newMessages,
                newEvents: messageFields?.newEvents,
                section_name: section.slug,
                view_name: view.slug,
                sequence_id,
                isCreate
              }))
        
              if(!handlerDefinitions.status) continue;
      
              setNoficationMessage([
                "Interpreting handler definitions",
                "Generating handler function structure",
                "Implementing business logic within handlers",
                "Integrating message and instance attributes",
                "Ensuring compliance with handler rules",
                "Reviewing generated handler code",
                "Finalizing handler implementation"
              ])
              const handlersCode = await dispatch(invokePostService('llmFetchHandlerCode', {
                generatedFields: handlerDefinitions?.generatedFields, 
                generatedViews: handlerDefinitions?.generatedViews, 
                tables, 
                newTransactions: handlerDefinitions?.newTransactions,
                newFields: handlerDefinitions?.newFields,
                newMessages: handlerDefinitions?.newMessages,
                newEvents: handlerDefinitions?.newEvents,
                handlersDef: handlerDefinitions?.handlersDef,
                structuredTransaction: handlerDefinitions?.structuredTransaction,
                correspondingSection: handlerDefinitions?.correspondingSection,
                sequence_id,
                isCreate
              }))
      
              if(!handlersCode.status) continue;

              setNoficationMessage([
                "Initiating handler code validation",
                "Checking syntax correctness",
                "Validating handler execution rules",
                "Ensuring correct use of instance and message data",
                "Verifying absence of forbidden operations",
                "Running consistency and completeness checks",
                "Confirming handler code validity"
              ])
              const handlerValidation = await dispatch(invokePostService('llmHandlerValidation', {
                handlersDef: handlersCode?.handlersCode?.events,
                tables,
                sequence_id,
                isCreate
              }))
              if(handlerValidation?.isHandlersValid){
                iterate = false;
                newTransactions.push(...(handlersCode?.newTransactions || []))
                newFields.push(...(handlersCode?.newFields || []))
                newMessages.push(...(handlersCode?.newMessages || []))
                newEvents.push(...(handlersCode?.newEvents || []))
                newMappedTransactions.push(...(messageFields?.generatedMappedTransactions || []))
                newHandlers.push(...(handlersCode?.handlersCode?.events || []))
                generatedFields = handlersCode?.generatedFields;
                generatedViews = handlersCode?.generatedViews
              }else{
                continue;
              }
          }

        }
      }
      
      return {newTransactions, newFields, newMessages, newEvents, newMappedTransactions, newHandlers, generatedFields, generatedViews}
      
    }catch(error){
      return false
    }
  }

  const generateTestsuites = async ({ scenarios, sequence_id }) => {
    // await the dispatch so this helper always resolves to the final response (not a pending promise)
    console.log("Scenarios---------", scenarios)
    return await dispatch(invokePostService("llGenerateSimulationTestsuites", { scenarios, sequence_id }, {}));
  };

  const handleProceedTransactionsGeneration = async (updatedTransactionsList) => {
    try {
      setOpenListModal(false);
      dispatch(updateAiAssistant({promptModalOpen: false}));
      dispatch(setAiRequestEntity("transaction"))

      const sequence_id = sequenceId || generateMongoId();

      const isTransactionsModified = hasArrayDifference(aiGeneratedItems, updatedTransactionsList);
      if(isTransactionsModified){
        const updateData = { transactions: updatedTransactionsList }
        await dispatch(invokePostService("updateLLMResponseInTrainingData", {sequence_id, updateData, type: "transaction_list"}, {}));
      }
      setNoficationMessage([
        'Understanding purpose of the transaction',
        'Selecting participating components',
        'Defining the events',
        'Preparing event type',
        'Applying platform rules and checks',
        'Finalizing the transaction'
      ])

      updatedTransactionsList.forEach(item => {
        addProgressItem({
          id: item.name,
          name: item.name,
          status: "pending",
        });
      });

      for (const [index, item] of updatedTransactionsList.entries()) {
        const id = item.name;
        const {blueprintId} = getDetailsFromUrl();

        if(!blueprintId) return;
        try {

          updateProgressItem(id, {
            status: "generating",
          });
          const prompt = `${item.name} - ${item.description}`;

          
          const response = await generateTransaction(prompt, undefined, sequence_id, item.name);

          updateProgressItem(id, {
            status: response?.status ? "completed" : "error",
          });
          dispatch(setReRender());
          if (index === 0 && screen !== "transaction" && response.data && response.data._id) {
            router.push(`/blueprint/${slug}/${blueprintId}/transaction/${response.data._id}`)
          }
        } catch (error) {
          console.error("Transaction generation failed:", error);
          updateProgressItem(id, {
            status: "error",
          });
        }
      }
      dispatch(updateAiAssistant({loading: false}));
      dispatch(setAiRequestEntity(null))
      setTimeout(() => {
        setAiProgress([]);
      }, 3000);
    } catch (error) {
      dispatch(updateAiAssistant({loading: false}));
      setLoading(false);
      dispatch(setAiRequestEntity(null))
      console.error("Transaction generation failed:", error);
    }
  }

  const handleProceedViewsGeneration = async (modifiedViewsList) => {
    try {
      console.log("handleProceedViewsGeneration----------------------------")
      dispatch(setAiRequestEntity("view"))
      dispatch(updateAiAssistant({loading: true}));
      const sequence_id = sequenceId || generateMongoId();

      const isViewsModified = hasArrayDifference(aiGeneratedItems, modifiedViewsList);

      if(isViewsModified){
        const updateData = { views: modifiedViewsList }
        await dispatch(invokePostService("updateLLMResponseInTrainingData", {sequence_id, updateData, type: "views_list"}, {}));
      }

      setOpenListModal(false);
      dispatch(closeAiAssistantModal());

      modifiedViewsList.forEach(item => {
        addProgressItem({
          id: item.name,
          name: item.name,
          status: "pending",
        });
      });

      const availableViews = [
        ...allViews.map(({ name, desc: description, _id }) => ({ name, description, _id })),
        ...modifiedViewsList.map(v => ({ ...v, _id: generateMongoId() }))
      ];

      for (const [index, item] of modifiedViewsList.entries()) {
        const id = item.name;
        const {blueprintId} = getDetailsFromUrl()
        if(!blueprintId) return;
        try {
          updateProgressItem(id, {
            status: "generating",
          });

          const prompt = `${item.name} - ${item.description}`;

          
          const response = await generateSingleView({ prompt, availableViews, type: item.view_type, sequence_id, viewName: item.name });
          console.log("generateSingleView_response: ", response)
          const viewChanges = response?.data?.views;
          const generatedView = viewChanges?.create?.[0];
          
          const viewTransactionResult = await generateViewTransactionWithAI({newView: generatedView, sequence_id, view_type: item.view_type, viewChanges, setNoficationMessage, dispatch});
          console.log("viewTransactionResult: ", viewTransactionResult)

          
          dispatch(setInnerScreenRender());

          const viewId = generatedView?._id;
          if (viewTransactionResult.status && index === 0 && screen !== "view" && viewId) {
            router.push(`/blueprint/${slug}/${blueprintId}/view/${viewId}`)
          }
          updateProgressItem(id, {
            status: viewTransactionResult?.status ? "completed" : "error",
          });
        } catch (error) {
          console.error("View generation failed:", error);
          updateProgressItem(id, {
            status: "error",
          });
        }
      }
      dispatch(updateAiAssistant({loading: false}));
      dispatch(setAiRequestEntity(null))
      setTimeout(() => {
        setAiProgress([]);
      }, 3000);
    } catch (error) {
      dispatch(updateAiAssistant({loading: false}));
      setLoading(false);
      dispatch(setAiRequestEntity(null))
      console.error("Transaction generation failed:", error);
    }
  }

  const onCompleteDatabaseGeneration = (delegate) => {
    try {
        dispatch(setTabOnFocus(5));
        const focusElement = {
          id: String(delegate._id), 
          type: 'external_function', 
          name: delegate.name, 
          protocol: delegate?.attributes?.type, 
          icon: delegate?.icon,
          desc: delegate?.attributes?.desc,
          item: delegate

        }
        
        dispatch(setFocusElement(focusElement));
        
        if(!rightDrawerStatus) {
          dispatch(toggleRightDrawer());
        }
    } catch (error) {
      console.error("Handling database generation handling failed. ", error);
    }
  }

  // To proceed with database structure generation
  const proceedDatabaseProfileSchemaGeneration = (modifiedItems) => {
    const delegate  = (requestContext?.entityType === "database_profile" && requestContext?.entity?._id) ? requestContext?.entity : showDBMissingAlert?.delegate;
    const delegateId = String(delegate?._id);
    try {
        setOpenListModal(false);
        dispatch(closeAiAssistantModal());
        dispatch(setAiRequestEntity("database_profile"))
        

        addProgressItem({
          id: delegateId,
          name: delegate.name,
          status: "pending",
        });
        

        setNoficationMessage([
          "Generating table structures",
          "Defining column data types",
          "Assigning primary keys",
          "Establishing foreign key relationships",
          "Applying column constraints",
          "Creating indexes for optimized queries",
          "Validating table relationships and constraints",
          "Optimizing schema for performance",
          "Finalizing database schema"
        ]); 

        updateProgressItem(delegateId, {
          status: "generating",
        });
        
        dispatch(invokePostService('llmGenerationSystemModelDBProfileSchema', { delegate_id: String(delegate?._id), sequence_id: sequenceId, database_tables:modifiedItems, isCreate: true }, {})).then((response) => {
                if (response?.status) {
                    updateProgressItem(delegateId, {
                      status: "completed" 
                    });
                    dispatch(setReRender());
                    onCompleteDatabaseGeneration(delegate)
                }else {
                    updateProgressItem(delegateId, {
                      status: "error"
                    });
                    if (response.message) {
                        setLoading(false)
                        dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
                    }
                }
                dispatch(updateAiAssistant({loading: false}));
                dispatch(setAiRequestEntity(null))
                setTimeout(() => {
                  setAiProgress([]);
                }, 3000);
            }).catch((error) => {
                console.error("Generating database profiles failed. ", error);
                updateProgressItem(delegateId, {
                  status: "error"
                });
                dispatch(handleSnackBar({ open: true, message: "Something went wrong", severity: "error" }));
                dispatch(updateAiAssistant({loading: false}));
                dispatch(setAiRequestEntity(null))
            });

    } catch (error) {
        updateProgressItem(delegateId, {
          status: "error"
        });
        console.error("Generating database profiles failed. ", error);
        dispatch(handleSnackBar({ open: true, message: "Something went wrong", severity: "error" }));
        dispatch(updateAiAssistant({loading: false}));
        dispatch(setAiRequestEntity(null))


    }
}

  const handleProceedSimulationGeneration = async (modifiedSimulationList) => {

    try {

      setOpenListModal(false);
      dispatch(updateAiAssistant({ promptModalOpen: false }));
      dispatch(setAiRequestEntity("simulation"))

      const sequence_id = sequenceId || generateMongoId();

      modifiedSimulationList.forEach(item => {
        addProgressItem({
          id: item.name,
          name: item.name,
          status: "pending",
        });
      });

      for (const [index, item] of modifiedSimulationList.entries()) {
        const id = item.name;
        const { blueprintId } = getDetailsFromUrl();

        if (!blueprintId) return;
        try {
          setNoficationMessage([
            'Understanding test objectives',
            'Selecting related transactions and flows',
            'Defining testsuites and testcases',
            'Applying validation rules',
            'Finalizing the test suite'
          ])

          updateProgressItem(id, {
            status: "generating",
          });
          const prompt = [item];

          const response = await generateTestsuites({ scenarios: prompt, sequence_id })

          updateProgressItem(id, {
            status: response?.status ? "completed" : "error",
          });

          dispatch(setReRender());
          if (index === 0 && screen !== "transaction" && response.data && response.data._id) {
            router.push(`/blueprint/${slug}/${blueprintId}/transaction/${response.data._id}`)
          }

          setLoading(false);

          if (response.status) {
            setOpenListModal(false);
            dispatch(updateAiAssistant({ promptModalOpen: false, loading: true }));
            dispatch(setReRender());
            // const generatedTestsuites = response?.data?.generatedTestsuitesWithID || [];
            // generateTestsuiteMessages(generatedTestsuites, sequence_id)
          } else {
            console.error(response.message);
            dispatch(handleSnackBar({ open: true, message: response.message || "Testsuite generation failed", severity: 'error' }))
          }
          
        } catch (error) {
          console.error("TestSuite generation failed:", error);
          updateProgressItem(id, {
            status: "error",
          });
        }
      }
      dispatch(updateAiAssistant({ loading: false }));
      dispatch(setAiRequestEntity(null))

      setTimeout(() => {
        setAiProgress([]);
      }, 3000);

    } catch (error) {
      dispatch(updateAiAssistant({loading: false}));
      setLoading(false);
      dispatch(setAiRequestEntity(null))
      console.error("Testsuites generation failed:", error);

    }





  }

const validateViewWithExisting = (updatedList) => {
  return validateNames({
    modifiedItems: updatedList,
    entities: viewList,
    entityLabel: "View"
  });
};

const validateTxWithExisting = (updatedList) => {
  return validateNames({
    modifiedItems: updatedList,
    entities: transactionList,
    entityLabel: "Transaction"
  });
};

const validateTestSuitesWithExisting = (updatedList) => {
  return validateNames({
    modifiedItems: updatedList,
    entities: testSuitesList,
    entityLabel: "TestSuites"
  });
};

const validateDatabaseProfileWithExisting = (updatedList) => {
  return validateNames({
    modifiedItems: updatedList,
    entities: [],
    entityLabel: "Table"
  });
};

const validations = {
  view: validateViewWithExisting,
  transcation: validateTxWithExisting,
  testsuite: validateTestSuitesWithExisting,
  table: validateDatabaseProfileWithExisting
}



const validateNames = ( {modifiedItems = [], entities = [], entityLabel = "", nameKey = "name"}) => {


  const normalize = (value) => value?.trim().toLowerCase();

  const errors = [];

  const seenNames = new Set();
  const existingNames = new Set(
    entities
      .map(e => normalize(e?.[nameKey]))
      .filter(Boolean)
  );
  
  modifiedItems.forEach((item, index) => {
    const normalizedName = normalize(item[nameKey]);

    if (!normalizedName) return;

    if (seenNames.has(normalizedName)) {
      errors.push({
        type: "duplicate_in_list",
        index: index,
        key: `${item.name}_${index}`,
        message: `A ${entityLabel?.toLowerCase()} with this name already exists in the list.`
      });
      return; // stop checking further for this item
    }

    seenNames.add(normalizedName);

    if (existingNames.has(normalizedName)) {
      errors.push({
        type: "duplicate_in_existing",
        index: index,
        key: `${item.name}_${index}`,
        message: `This ${entityLabel?.toLowerCase()} name is already in use`
      });
    }
  });

  return errors;
};

  const onProceedGeneration = async (modifiedItems) => {
    console.log("onProceedGeneration----------------------------")
    try {
      setValidationError([]);
      dispatch(updateAiAssistant({loading: true}));

      if(isGenerateDBLinkClicked){
        proceedDatabaseProfileSchemaGeneration(modifiedItems)
        return;
      }
      if (entityType === "transaction") {

        const validationErrors = validateNames({modifiedItems, entities: transactionList, entityLabel : "Transaction" });
        
        if (validationErrors.length) {
          setValidationError(validationErrors);
          dispatch(updateAiAssistant({loading: false}));
          setLoading(false);
          return; 
        }


        handleProceedTransactionsGeneration(modifiedItems);

      } else if (entityType === "testsuite") {

        const validationErrors = validateNames({modifiedItems, entities: testSuitesList, entityLabel : "TestSuite" });

        if (validationErrors.length) {
          setValidationError(validationErrors);
          dispatch(updateAiAssistant({loading: false}));
          setLoading(false);
          return; 
        }


        await handleProceedSimulationGeneration(modifiedItems)

  
      } else if (entityType === "views") {

        const validationErrors = validateNames({modifiedItems, entities: viewList, entityLabel : "View" });


        if (validationErrors.length) {
          setValidationError(validationErrors);
          dispatch(updateAiAssistant({loading: false}));
          setLoading(false);
          return; 
        }


        handleProceedViewsGeneration(modifiedItems);

      } else if (entityType === "database_profile") {
        proceedDatabaseProfileSchemaGeneration(modifiedItems);
      }


    } catch (error) {
      dispatch(handleSnackBar({ open: true, message: "Something went wrongs", severity: "error" }));
    }
  };


  const addProgressItem = (item) => {
    setAiProgress((prev) => [...prev, item]);
  };


  const updateProgressItem = (id, changes) => {
    setAiProgress((prev) => {
      return prev.map((p) => {
        if (p.id !== id) return p;
        const updated = { ...p, ...changes };
        return updated;
      });
    });
  };


  const generateTestsuiteMessages = async (testsuites, sequence_id) => {
    try {
      testsuites.forEach((testsuite, index) => addProgressItem({
        id: testsuite.slug_name,
        name: `Generate testsuite ${testsuite.slug_name}`,
        status: 'pending'
      }))

      for (let [index, testsuite] of testsuites.entries()) {
        try {
          updateProgressItem(testsuite.slug_name, { status: "generating" })
          const response = await dispatch(invokePostService('llmGenerateTestsuiteMessages', {
            testsuite, sequence_id
          }, []));
          if (response.status) {
            if (index === 0) {
              const testcaseId = testsuite.testcases?.length > 0 ? testsuite.testcases[0]?.id : null;
              history.push(testcaseId ? `/blueprint/${slug}/${blueprintId}/testsuite/${testsuite.id}?testcase=${testcaseId}` : `/blueprint/${slug}/${blueprintId}/testsuite/${testsuite.id}`);
            }
            updateProgressItem(testsuite.slug_name, { status: "completed" })
          } else {
            updateProgressItem(testsuite.slug_name, { status: "error" })
          }
        } catch (error) {
          updateProgressItem(testsuite.slug_name, { status: "error" })
        }
      }
      dispatch(updateAiAssistant({loading: false}));
      setTimeout(() => {
        setAiProgress([]);
      }, 3000);

    } catch (error) {
      console.error("Message generation failed.", error);
      dispatch(handleSnackBar({ open: true, message: "Something went wrong", severity: "error" }));
    }
  }


  const handlePromptOptionsClick = (event) => {
    setMenuPosition({
      top: event.clientY - 8, // 👈 small offset upward (safe default)
      left: event.clientX,
    });

    setMenuAnchorEl(true)
  }


   const generateDatabaseTablesWithAI  = (delegate_id) => {
    try {
        setLoading(true);
        dispatch(updateAiAssistant({loading: true}));
        let cancelInterval = handleProgressMessages(2000, [
          'Analysing and understanding the clusterlets',
          'Finding all required tables',
          'Deciding the role of each table',
          'Identifying fields for the tables'
        ]);

        const sequence_id = generateMongoId();
        setSequenceId(sequence_id);
        const isCreate = requestContext?.isCreate ? requestContext?.isCreate : true;
        dispatch(invokePostService('llmGenerationSystemModelDBTables', { delegate_id, sequence_id, isCreate, prompt }, {})).then((response) => {
                if (response?.status) {
                    setLoading(false)

                    setAiGeneratedItems(response.data.databaseStructureTables || [])
                    setOpenListModal(true);
                }else {
                    if (response.message) {
                        setLoading(false)
                        dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
                  }
                }
                cancelInterval();
                dispatch(updateAiAssistant({loading: false}));
            }).catch((error) => {
                setLoading(false);
                cancelInterval();
                console.error("Generating database profiles failed. ", error);
                dispatch(handleSnackBar({ open: true, message: "Something went wrong", severity: "error" }));
                dispatch(updateAiAssistant({loading: false}));
            });

    } catch (error) {
        setLoading(false)
        console.error("Generating database profiles failed. ", error);
        dispatch(handleSnackBar({ open: true, message: "Something went wrong", severity: "error" }));
        dispatch(updateAiAssistant({loading: false}));
        dispatch(setAiRequestEntity(null));

    }
}
 

  return (
    <>
      <AlertDialog
        open={isAlertDialog}
        title={'Are you sure?'}
        content={isAlertDialog?.dependencies ? isAlertDialog?.dependencies :  isAlertDialog?.message}
        onProceed={onDangerContinue}
        onClose={() => setAlertDialog(false)}
        proceedText='Proceed'
        isLoading={isLoading}
      />
      <Modal
        open={promptModalOpen}
        closeAfterTransition
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        id='prompt-modal'
        // onBackdropClick={() => !isLoading ? setOpenPrompt(false) : null}
      >
        <Fade in={promptModalOpen}>
          <div
            className={classes.modalContentWrapper}
          >
            <div className={classes.modalContent}>
              <textarea
                ref={textareaRef}
                id={"prompt-modal-textarea"}
                className={classes.textarea}
                rows={5}
                placeholder={generatePlaceholder()}
                onChange={e => setPrompt(e.target.value)}
                disabled={isLoading}
              />
              {isLoading && progressMessage && (
                <div id="progress-message" style={{ color: "#000", fontStyle: "italic", marginTop: "0.5rem", display: 'flex', alignItems: 'flex-end' }}>
                  {progressMessage}
                  <div style={{ paddingLeft: '2px' }}>
                    <span class="dot-loader" aria-label="Loading"></span>
                  </div>
                </div>
              )}

              {error && (
                <div className={classes.errorInline}>
                  ⚠ Prompt required.
                </div>
              )}

              {activeMenu.value === "views" && showDBMissingAlert && 
              <div className={'alert alert-warning'}>
                No database is configured yet. While optional, a database is recommended for better data organization and should ideally be created before defining views.{" "}
                {(isLoading && isGenerateDBLinkClicked) ? <> 
                Database structure is generating.. <CircularProgress size={14} color="white" />
                </>
              :
              <> <Link
                  component="button"
                  onClick={!isLoading ? onDBMissingAlertClick : undefined}
                  className={`${classes.alertLink} ${isLoading ? classes.disabledLink : ""}`}
                >
                  Click here
                </Link>{" "}
                to generate the database structure.
              </>
              }
              </div>
              }

              <div className={classes.buttonRow}>
                {showEntityFilter !== false && <Button
                  variant='outlined'
                  className={clsx(classes.button)}
                  startIcon={activeMenu.icon}
                  onClick={e => handlePromptOptionsClick(e)}
                  disabled={isLoading}
                  id='choice-btn'
                >
                  {activeMenu.title}
                </Button>}
                <CustomPromptMenu
                  items={menuOptions}
                  anchorEl={menuAnchorEl}
                  setAnchorEl={setMenuAnchorEl}
                  setActiveMenu={setActiveMenu}
                  menuPosition={menuPosition}
                  activeMenu={activeMenu}
                  clusterlets={clusterlets}
                  transactions={transactions}
                  events={events}
                />
                <div className={classes.actionButtons}>
                  <Button
                    variant="contained"
                    className={clsx(classes.button, classes.cancelBtn)}
                    onClick={() => dispatch(closeAiAssistantModal())}
                    disabled={isLoading}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    className={clsx(classes.button, classes.buttonGenerate)}
                    startIcon={(isLoading && !isGenerateDBLinkClicked) ? <CircularProgress size={20} color="white" /> : <StarsIcon />}
                    onClick={handleGenerate}
                    disabled={isLoading}
                  >
                    {(isLoading && !isGenerateDBLinkClicked) ? "Generating..." : "Generate"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
      {openListModal && <AiGeneratedItemsModal title={isGenerateDBLinkClicked ? DBProfileConfigurations.listModalTitle : null} formPlaceholders={isGenerateDBLinkClicked ? DBProfileConfigurations.formPlaceholders : null} messageList={isGenerateDBLinkClicked ? DBProfileConfigurations.messages : notificationMessages} selectedOption={isGenerateDBLinkClicked ? "dbstructure" : entityType} items={aiGeneratedItems} onCancel={onChangePrompt} onClose={onCloseListModal} onProceed={onProceedGeneration} isLoading={isLoading} validationError={validationError} validations={validations}/>}
      {aiProgress.length ? <AiGenerationNotifications messageList={notificationMessages} items={aiProgress} onClose={() => setAiProgress([])} /> : null}
    </>
  )
}

export default PromptModal;